import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import ReportDefinitions from '../../../../../common/config/ReportDefinitions';
import CapeUsageMonitoringReport from '../../components/CapeUsageMonitoringReport';
import {
  getColumns,
  getData,
  getGeneratedOnDateTime,
  getIsLoading,
} from '../redux/selectors/CapeUsageMonitoringByOperatorSelectors';

export function CapeUsageMonitoringByOperatorContainer(props) {
  return (
    <CapeUsageMonitoringReport
      reportId={ReportDefinitions.CAPE_USAGE_MONITORING_BY_OPERATOR_1000.id}
      columns={props.columns}
      isLoading={props.isLoading}
      generatedOnDateTime={props.generatedDateTime}
      data={props.data}
    />
  );
}

function mapStateToProps(state) {
  return {
    data: getData(state),
    generatedDateTime: getGeneratedOnDateTime(state),
    isLoading: getIsLoading(state),
    columns: getColumns(state),
  };
}

CapeUsageMonitoringByOperatorContainer.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  generatedDateTime: PropTypes.string,
  isLoading: PropTypes.bool,
  columns: PropTypes.arrayOf(PropTypes.object),
};

export default connect(mapStateToProps)(CapeUsageMonitoringByOperatorContainer);
